import { render, staticRenderFns } from "./BrandProductProfile.vue?vue&type=template&id=2fc3da78&scoped=true"
import script from "./BrandProductProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandProductProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BrandProductProfile.vue?vue&type=style&index=0&id=2fc3da78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3da78",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLtkAvatar: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkAvatar/CLtkAvatar.vue').default})
